/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrintOrderVo } from './PrintOrderVo';
import {
    PrintOrderVoFromJSON,
    PrintOrderVoFromJSONTyped,
    PrintOrderVoToJSON,
    PrintOrderVoToJSONTyped,
} from './PrintOrderVo';

/**
 * 
 * @export
 * @interface ResponseListPrintOrderVo
 */
export interface ResponseListPrintOrderVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListPrintOrderVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListPrintOrderVo
     */
    message?: string;
    /**
     * 
     * @type {Array<PrintOrderVo>}
     * @memberof ResponseListPrintOrderVo
     */
    data?: Array<PrintOrderVo>;
}

/**
 * Check if a given object implements the ResponseListPrintOrderVo interface.
 */
export function instanceOfResponseListPrintOrderVo(value: object): value is ResponseListPrintOrderVo {
    return true;
}

export function ResponseListPrintOrderVoFromJSON(json: any): ResponseListPrintOrderVo {
    return ResponseListPrintOrderVoFromJSONTyped(json, false);
}

export function ResponseListPrintOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListPrintOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PrintOrderVoFromJSON)),
    };
}

export function ResponseListPrintOrderVoToJSON(json: any): ResponseListPrintOrderVo {
    return ResponseListPrintOrderVoToJSONTyped(json, false);
}

export function ResponseListPrintOrderVoToJSONTyped(value?: ResponseListPrintOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PrintOrderVoToJSON)),
    };
}

